// extracted by mini-css-extract-plugin
export var wordContainer = "_qx-0";